import type { FullEngagementInfo } from "@be-miniapp/types"
import { BEAutoRideStatus } from "@be-miniapp/types"

import type { RideEngagement } from "../stores/ride-contracts"

export function getSessionId(
  sessionIdFromLocation?: string,
  sessionIdFromState?: string | number
): string {
  return sessionIdFromLocation || `${sessionIdFromState ?? ""}`
}

export function shouldShowBackButton(currentState: string): boolean {
  return currentState !== "finding-driver"
}

export function isPerfectRideActive(
  engagement?: RideEngagement | FullEngagementInfo
): boolean {
  const perfectRideEngagement = engagement as
    | (Partial<RideEngagement> & Partial<FullEngagementInfo>)
    | undefined

  return (
    (!!perfectRideEngagement?.in_perfect_ride ||
      !!perfectRideEngagement?.driver_in_perfect_ride) &&
    perfectRideEngagement?.status === BEAutoRideStatus.accepted
  )
}
